import React from 'react'
import { Field, Form, FormModal, FormSaveButton } from '@ztechapps/webui.form'
import { routesDef } from '../../config/routes'
import { useHistory } from '@ztechapps/common.hook'
import { VendorSelectCreatable } from '@ztechapps/vendor.webui'
import { useCreatePurchaseOrder } from '@ztechapps/purchase-order.common'
import type { NextFunction, PurchaseOrder } from '@ztechapps/common.contract'
import { AddNewButton } from './AddNewButton'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'

export type FormActionProps = {
  next?: NextFunction<PurchaseOrder>
}

const useFormAction = ({ next }: FormActionProps) => {
  const [onAdd] = useCreatePurchaseOrder()
  const history = useHistory()

  const initialValues = {}

  const validate = () => {
    const errors: any = {}

    return errors
  }

  const onSubmit = async (args) => {
    try {
      if (args?.vendor?.__isCreate) {
        args.vendor._id = undefined
      }

      const { data, errors } = await onAdd({
        input: {
          vendor: args?.vendor,
        } as PurchaseOrder,
      })

      if (errors) throw errors
      const newPurchaseOrder = data?.createPurchaseOrder

      // if then navigate to necessary field is no error then navigate to
      const route = routesDef.PurchaseItemPage.altPath({
        _id: newPurchaseOrder._id,
      })

      history.push(route)
      await next?.(newPurchaseOrder)
    } catch (e) {
      await next?.(null, e)
      throw e
    }
  }
  return { onSubmit, validate, initialValues }
}

export const AddForm = ({ next }: FormActionProps) => {
  const { initialValues, validate, onSubmit } = useFormAction({ next })
  return (
    <Form {...{ initialValues, validate, onSubmit, title: 'Add new purchase' }}>
      <Stack gap={2}>
        <FormContent />

        <HorizontalStack className="justify-content-end">
          <FormSaveButton text="Create" />
        </HorizontalStack>
      </Stack>
    </Form>
  )
}

export const AddFormModal = ({ next }: FormActionProps) => {
  const { initialValues, validate, onSubmit } = useFormAction({ next })
  return (
    <FormModal
      trigger={AddNewButton}
      initialValues={initialValues}
      validate={validate}
      onSubmit={onSubmit}
      title="Add new purchase"
    >
      <FormContent />
    </FormModal>
  )
}

export const FormContent = () => {
  return (
    <Field
      name="vendor"
      component={VendorSelectCreatable}
      label="Vendor"
      help="The vendor of this purchase"
      onChange
      autoFocus
    />
  )
}
